'use strict';
(() => {
  function init(scope = document) {
    const sections = [];
    if (scope.matches?.('[data-in-product]')) sections.push(scope);
    sections.push(...scope.querySelectorAll('[data-in-product]'));
    sections.forEach(section => {
      if (section.inStickyCleanup) section.inStickyCleanup();
      const bar = section.querySelector('[data-in-sticky-buy]');
      const boundary = section.querySelector('[data-in-purchase-end]');
      const form = section.querySelector('.in-product-form');
      if (!bar || !boundary || !form) return;
      const header = document.querySelector('.site-header');
      const mobile = matchMedia('(max-width: 767px)');
      let frame = 0;
      const update = () => {
        frame = 0;
        if (!section.isConnected) return;
        const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
        const show = mobile.matches && boundary.getBoundingClientRect().bottom <= headerBottom + 1;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', String(!show));
        bar.inert = !show;
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
      const resize = new ResizeObserver(schedule);
      resize.observe(form);
      resize.observe(section);
      if (header) resize.observe(header);
      addEventListener('scroll', schedule, {passive:true});
      addEventListener('resize', schedule, {passive:true});
      addEventListener('load', schedule, {once:true});
      visualViewport?.addEventListener('resize', schedule, {passive:true});
      section.inStickyCleanup = () => {
        removeEventListener('scroll', schedule);
        removeEventListener('resize', schedule);
        removeEventListener('load', schedule);
        visualViewport?.removeEventListener('resize', schedule);
        resize.disconnect();
        if (frame) cancelAnimationFrame(frame);
        delete section.inStickyCleanup;
      };
      bar.dataset.stickyReady = 'true';
      schedule();
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.matches?.('[data-in-product]')) event.target.inStickyCleanup?.();
    event.target.querySelectorAll('[data-in-product]').forEach(section => section.inStickyCleanup?.());
  });
})();
